'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../stores/CartStore.jsx');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore.jsx');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _Actions = require('../../Actions.jsx');

var _Actions2 = _interopRequireDefault(_Actions);

var _Utility = require('../../utils/Utility.jsx');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DineInAddressView = function (_React$Component) {
    _inherits(DineInAddressView, _React$Component);

    function DineInAddressView(props) {
        _classCallCheck(this, DineInAddressView);

        var _this = _possibleConstructorReturn(this, (DineInAddressView.__proto__ || Object.getPrototypeOf(DineInAddressView)).call(this, props));

        _this.onTableNumberChanged = function (e) {
            var tableNumber = e.target.value;
            if (tableNumber < 0) {

                //hide schedule Modal befoe
                //opening schedule modal
                _this.props.callBackParent();

                _this.setState({
                    slData: ""
                });

                _sweetalert2.default.fire({
                    title: 'Invalid Value!',
                    text: 'You are entering a negative value.',
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                }).then(function (result) {
                    if (result.isDismissed) {
                        var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                        if (scheduleOrderModal) {
                            scheduleOrderModal.style.display = "block";
                        }
                    }
                });

                return;
            }

            _this.setState({
                slData: e.target.value
            }, function () {
                _this.props.handleSlLocationData(_this.state.slData);
            });
        };

        _this.state = {
            slData: "",
            isDineInEnabled: false,
            dineInInstructions: "",
            orderType: "",
            serviceLocation: "",
            placeHolder: "",
            roomNumberTesting: "",
            typingTimeout: ""

        };
        return _this;
    }

    _createClass(DineInAddressView, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {

            var self = this;

            self.setState({
                orderType: "DineIn",
                slData: _CartStore2.default.getDineInServiceLocationData(),
                isDineInEnabled: _MainStore2.default.isDineInEnabled(),
                dineInInstructions: _CartStore2.default.getDineInInstructions(),
                serviceLocation: _CartStore2.default.getDineInServiceLocation(),
                placeHolder: self.getPlaceHolder()

            });
        }

        // componentDidMount(){
        //     this.setState({
        //         slData: this.props.onRoomNumberTesting
        //     },() => {
        //         // Actions
        //         //     .addDeliveryAddress
        //         //     (this.props.scheduleScreenStore.scheduleScreenUpdatedObject.orderType, null, -1);
        //     });
        // }


    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {

            if (nextProps) {

                if (!Utils.isEmpty(nextProps.slData)) {
                    this.setState({
                        slData: nextProps.slData
                    });
                }
            }
        }
    }, {
        key: 'getPlaceHolder',
        value: function getPlaceHolder() {

            var self = this;
            var serviceLocation = _CartStore2.default.getDineInServiceLocation();

            if (serviceLocation != null) {

                return "Enter " + serviceLocation;
            } else {
                return "Enter Table Number";
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'panel-default panel-border-less cart-box' },
                _react2.default.createElement(
                    'div',
                    { className: 'panel-default panel-border-less' },
                    this.state.isDineInEnabled ? _react2.default.createElement(
                        'div',
                        { className: 'curbside-form-div' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'cart-heading f16-default' },
                            this.state.serviceLocation,
                            ':'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-lg-12 form-group curbside-pickup-instruction mb-2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                this.state.dineInInstructions ? _react2.default.createElement(
                                    'label',
                                    { className: 'address-width-ctrl selected-address-label cart-header' },
                                    this.state.dineInInstructions
                                ) : null,
                                _react2.default.createElement('input', {
                                    type: 'text',
                                    id: 'table_num',
                                    name: 'table_num',
                                    className: 'form-control curbside-input-field text-secondary-light rounded-sm',
                                    placeholder: this.state.placeHolder,
                                    title: this.state.placeHolder,
                                    onChange: this.onTableNumberChanged
                                    //  value={this.state.slData}
                                    , value: this.state.slData
                                })
                            )
                        )
                    ) : null
                )
            );
        }
    }]);

    return DineInAddressView;
}(_react2.default.Component);

exports.default = DineInAddressView;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/DineInAddressView.jsx
// module id = 497
// module chunks = 0